const topdata = [
  {
    id: 1,
    title: "Mobile",
    img: "/images/products/iphone-13.png",
    path: "/product-details/",
    href: "/mobile",
  },
  {
    id: 2,
    title: "TV",
    img: "/images/products/samsung.png",
    path: "/product-details/",
    href: "/tv",
  },
  {
    id: 3,
    title: "HeadPhone",
    img: "/images/products/sony1000xm4-1.png",
    path: "/product-details/",
    href: "/headphone",
  },
  {
    id: 4,
    title: "Laptop",
    img: "/images/products/hplapi_1.jpg",

    path: "/product-details/",
    href: "/laptop",
  },
  {
    id: 5,
    title: "Earbuds",
    img: "/images/products/jbl100-1.png",
    path: "/product-details/",
    href: "/earbuds",
  },
  {
    id: 6,
    title: "Neckbands",
    img: "/images/products/jbl200bt-1.png",
    path: "/product-details/",
    href: "/neckband",
  },
];
export default topdata;
